module.exports = __webpack_public_path__ + "static/media/whiteHeartIcon.0ef4bd60.svg";